import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';
import { withUserType } from '../withUserType';

// No tabs on the shell: the entity-type strip (Suppliers / Assets / Parts, the latter two disabled
// until the backend can materialize them) is rendered by the list itself — see
// RequestsToAddSuppliersIndexPage — so it stays in one place across this page and the admin tab that
// mounts the same list.
const RequestsToAddOverviewPage: FC<any> = ({ childRoutes, userType }): React.ReactElement => (
	<>
		<Route
			path={`/${userType}/requestsToAdd/overview`}
			exact={true}
			render={() => (
				<Redirect
					to={{
						pathname: `/${userType}/requestsToAdd/overview/suppliers`,
					}}
				/>
			)}
		/>
		<OverviewShell
			title="Suggested Entities"
			childRoutes={childRoutes}
			className="requestsToAddPage"
		/>
	</>
);

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withUserType(
	withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(RequestsToAddOverviewPage))
);
